import React from 'react';
import { Mail } from 'lucide-react';
import { FieldDisplayProps } from '../../types';

export const EmailFieldDisplay: React.FC<FieldDisplayProps> = ({
  value,
  onStartEditing,
  isReadOnly,
}) => {
  const handleClick = () => {
    if (!isReadOnly) {
      onStartEditing();
    }
  };

  if (!value) {
    return (
      <div
        className="pill custom-field-pill editable empty-placeholder"
        onClick={handleClick}
      />
    );
  }

  return (
    <div
      className="email-cell editable"
      onClick={handleClick}
      onDoubleClick={handleClick}
      title={value}
    >
      <Mail size={14} className="email-icon" />
      <span className="email-text">{value}</span>
    </div>
  );
};

export default EmailFieldDisplay;
